import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors, calculateSpacing } from '@vds-core/theme';
import { calculateRem } from '@uie/javascript-style-helpers';
import { withVDSManager } from '@vds-core/utilities';

function _calculateLineColor(type, inverted) {
  var lineColor = colors.black;
  if (type === 'accent') lineColor = colors.red;else if (inverted) lineColor = colors.white;else if (type === 'xLight') lineColor = colors.grayLight;
  return lineColor;
}

var propTypes = {
  /**
   * Weight of the line that will be displayed.
   */
  type: PropTypes.oneOf(['heavy', 'light', 'xLight', 'accent']),

  /**
   * If true, this will invert the colors of the line.
   */
  inverted: PropTypes.bool,

  /**
   * @deprecated
   */
  active: PropTypes.bool,

  /**
   * @ignore
   */
  noMargin: PropTypes.bool,

  /**
   * @ignore
   * This takes type and inverted parameters and returns a hex used for line color
   */
  calculateLineColor: PropTypes.func,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string
};
var defaultProps = {
  type: 'heavy',
  inverted: false,
  calculateLineColor: _calculateLineColor,
  active: false,
  //DEPRECATED
  noMargin: false //DEPRECATED

};
var StyledLine = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledLine",
  componentId: "sc-7j8mur-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  width: 100%;\n  background-color: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n"])), function (_ref) {
  var type = _ref.type;
  return calculateRem(type === 'heavy' || type === 'accent' ? 4 : 1);
}, function (_ref2) {
  var calculateLineColor = _ref2.calculateLineColor,
      type = _ref2.type,
      inverted = _ref2.inverted;
  return calculateLineColor(type, inverted);
}, function (_ref3) {
  var noMargin = _ref3.noMargin;
  return noMargin ? calculateRem(0) : calculateSpacing('6X', 'rem');
}, function (_ref4) {
  var noMargin = _ref4.noMargin;
  return noMargin ? calculateRem(0) : calculateSpacing('6X', 'rem');
});

var Line = function Line(props) {
  var type = props.type,
      inverted = props.inverted,
      noMargin = props.noMargin,
      calculateLineColor = props.calculateLineColor,
      id = props.id;
  return /*#__PURE__*/React.createElement(StyledLine, _extends({}, props, {
    id: id,
    type: type,
    inverted: inverted,
    calculateLineColor: calculateLineColor,
    noMargin: noMargin
  }));
};

Line.propTypes = propTypes;
Line.defaultProps = defaultProps;
export default withVDSManager(Line);